import React from 'react'

import { Trigger, Observe } from '~components/Markdown'
import style from './Choose.module.scss'

import { FiCheckCircle, FiCircle } from 'react-icons/fi'

const Choose = ({
  option,
  value,
  color = '',
  children,
}) => (
  <Trigger option={option} value={value}>
    <Observe option={option} value={value}>
      <div className={ style.choose } tabIndex='1' data-color={ color } >
        <FiCircle /><FiCheckCircle />
        { children }
      </div>
    </Observe>
  </Trigger>
)

export default Choose